// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"59fe0987","444":"1a5939d2"}[chunkId] + ".chunk.css";
};